// useResourcePreloader.js (refactored: simplified, removed unnecessary timeouts, ensured progress is always forward)
import { useEffect, useState, useCallback, useRef } from "react";
import { resourceLoader } from "../utils/resourceLoader";

export const useResourcePreloader = (resources = []) => {
  const [resourcesLoaded, setResourcesLoaded] = useState(false);
  const [progress, setProgress] = useState(0);
  const isMountedRef = useRef(true);

  const handleProgressUpdate = useCallback((newProgress) => {
    setProgress((prev) => Math.max(prev, newProgress)); // 只允许进度前进
    if (newProgress >= 100) {
      setResourcesLoaded(true);
    }
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    const loadResources = async () => {
      resourceLoader.addProgressListener(handleProgressUpdate);
      resourceLoader.registerResources(resources);
      await resourceLoader.preloadAll();

      if (isMountedRef.current) {
        const finalProgress = resourceLoader.getProgress();
        setProgress(finalProgress);
        if (finalProgress >= 100) {
          setResourcesLoaded(true);
        }
      }
    };

    loadResources().catch((err) => {
      console.error("[useResourcePreloader] 加载出错", err);
      if (isMountedRef.current) {
        setResourcesLoaded(true);
      }
    });

    return () => {
      isMountedRef.current = false;
      resourceLoader.removeProgressListener(handleProgressUpdate);
    };
  }, [resources, handleProgressUpdate]); // 依赖 resources，确保重新加载时更新

  return { resourcesLoaded, progress };
};
